import React from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useDispatch } from 'react-redux';
import Image from 'next/image';
import { useTheme } from 'next-themes';

import { CallCalling, CurrencySmall, Sms } from '@/icons/index';
import {
  UpdateInstagram,
  UpdateWhatsapp,
  UpdateFacebook,
} from '@/icons/social';
import CardShapes from '@/icons/CardShapes';
import { actions as cabinetActions } from '@/domains/cabinet';
import { toCapitalise } from '@/utils/toCapitalise';

import Button from '../Button/Button';
import SectionTitle from '../SectionTitle/SectionTitle';
import LinkNumbers from '../LinkNumbers/LinkNumbers';

import styles from './styles.module.scss';

const TariffCard = ({ item, onClick = () => null, className }) => {
  const { t, lang } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const clickHandler = () => {
    dispatch(cabinetActions.setTariffModal(true));
    dispatch(cabinetActions.setIsPackageOrTariff(item?.type === 'tariff'));
    dispatch(cabinetActions.setSelectedTariff(item));
  };
  return (
    <div
      className={classNames([
        styles.card,
        {
          [styles.black]: item?.black,
          [styles.hot]: item?.hot_icon,
          [styles.mascotSmall]: item?.mascot_position === 'top',
          [styles.mascotMiddle]: item?.mascot_position === 'middle',
          [styles.mascotBottom]: item?.mascot_position === 'bottom',
        },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {item?.hot_icon && (
        <div className={styles.hotIcon}>
          <Image
            src={item.hot_icon}
            alt='Hot tariff'
            title='Hot tariff'
            loading='lazy'
            layout='fill'
          />
        </div>
      )}
      {item?.mascot_icon && (
        <div className={styles.mascot}>
          <Image
            src={item.mascot_icon}
            alt='Mascot'
            title='Mascot'
            loading='lazy'
            layout='fill'
          />
        </div>
      )}
      {item?.corner_text && (
        <div className={styles.profitableCorner}>{item.corner_text}</div>
      )}
      {item?.ussd && (
        <div className={styles.backgroundWrapper}>
          <div className={styles.tag}>
            {item?.top_icon && (
              <Image
                src={
                  theme?.resolvedTheme === 'dark' && item?.dark_mode_top_icon
                    ? item?.dark_mode_top_icon
                    : item?.top_icon
                }
                width={20}
                height={20}
                alt='tariff tag icon'
                title='tariff tag icon'
              />
            )}
            <label>{toCapitalise(item?.type)}</label>
          </div>
          <div className={styles.top}>
            <div className={styles.titleTop}>
              {item?.name && (
                <SectionTitle
                  titleModify={classNames(styles.title, 'title--large')}
                >
                  {item?.name}
                </SectionTitle>
              )}

              {/* {item?.top_text && (
                <div className={styles.popular}>{item.top_text}</div>
              )} */}
              <div className={styles.rectangle}></div>
            </div>
            <div className={styles.priceContainer}>
              <span className={styles.price}>{item?.price} </span>
              <div className={styles.text}>
                <span>₼/{item?.price_text}</span>
              </div>
              {/* {item?.bottom_text && (
                <div className={styles.profitableText}>{item.bottom_text}</div>
              )} */}
            </div>
            {!!item?.ussd && (
              <div className={styles.number}>
                <LinkNumbers numbers={item?.ussd} />
                {item?.text_after_ussd && (
                  <p className={styles.ussd_label}>{item.text_after_ussd}</p>
                )}
              </div>
            )}
          </div>
          <CardShapes />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.contentContainer}>
          <ul className={styles.list}>
            {!!item?.sections &&
              item?.sections?.map((section) => (
                <li key={section.heading_text}>
                  <div className={styles.itemContent}>
                    <Image
                      src={
                        theme?.resolvedTheme === 'dark' &&
                        section?.dark_mode_left_icon
                          ? section?.dark_mode_left_icon
                          : section?.left_icon
                      }
                      alt={section.heading_text}
                      title={section.heading_text}
                      height={24}
                      width={24}
                      loading='lazy'
                    />
                    <div className={styles.info}>
                      <div className={styles.itemIcon}>
                        <span className={styles.tariff}>{section?.text}</span>
                        <div className={styles.icons}>
                          {section?.right_icons?.map((icon, index) => (
                            <Image
                              key={index}
                              src={icon}
                              alt={section.heading_text}
                              title={section.heading_text}
                              height={24}
                              width={24}
                              loading='lazy'
                            />
                          ))}
                        </div>
                      </div>
                      <span className={styles.text}>
                        {section?.heading_text}
                      </span>
                    </div>
                  </div>
                </li>
              ))}

            {/* dont see data */}
            {!!item?.callRoamingData && (
              <li>
                <div className={styles.itemContent}>
                  <CallCalling />
                  <div className={styles.info}>
                    <span className={styles.text}>Calls & Roaming</span>
                    <span className={styles.tariff}>
                      {item.callRoamingData.price} <CurrencySmall width={20} />{' '}
                      / {item.callRoamingData.access}
                    </span>
                  </div>
                </div>
              </li>
            )}
            {/* dont see data */}
            {!!item?.socialMediaData && (
              <li>
                <div className={styles.itemContent}>
                  <Sms />
                  <div className={styles.info}>
                    <span className={styles.text}>Social Media</span>
                    <span className={styles.tariff}>
                      {item.socialMediaData.access}
                    </span>
                  </div>
                </div>
                {!!item.socialMediaData?.instruments && (
                  <div className={styles.icon}>
                    {item.socialMediaData.instruments?.facebook && (
                      <UpdateFacebook />
                    )}
                    {item.socialMediaData.instruments?.instagram && (
                      <UpdateInstagram />
                    )}
                    {item.socialMediaData.instruments?.whatsapp && (
                      <UpdateWhatsapp />
                    )}
                  </div>
                )}
              </li>
            )}
          </ul>
          {!!item?.additions &&
            item?.additions?.map((item, index) => {
              return (
                <div className={styles.infoText} key={index}>
                  <div className={styles.plus}>+</div>
                  <span>{item}</span>
                </div>
              );
            })}
        </div>
        <div
          className={`${styles.contentBottom} ${
            item?.button_slug && styles.contentBottom__popUp
          }`}
        >
          {item?.button_slug && (
            <Button
              Component={'a'}
              variant={'outline'}
              size={'normal'}
              onClick={onClick}
              href={
                item?.button_slug
                  ? item?.button_slug
                  : item?.external_link?.concat(`?___store=${lang}`)
              }
              className={`${item?.button_slug && styles.seeMore}`}
              data-testid={'tariff-see-more'}
            >
              {t('common:See more')}
            </Button>
          )}

          {item?.isSubscribable && (
            <Button
              size={'normal'}
              onClick={clickHandler}
              data-testid='tariff-subscribe-button'
              className={`bkc-gtm_tracking
            ${!item?.button_slug ? 'external_link' : ''} ${item?.name} ${
                styles.button
              }
              ${item?.button_slug && styles.button__tariffButton}
              `}
            >
              {t('common:Subscribe')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TariffCard;
